import { config } from '@config'
import { OrderType } from '@modules/common/models/enums/OrderManagement'
import { HttpService } from '@services/HttpService'
import { ORDER_SERVICE_ENDPOINTS } from '../constants/apiConstants'
import OrderDataService from './OrderDataService'
import { PRODUCT_SERVICE_ENDPOINTS } from '@modules/showroom/productCollection/enhancedView/constants/cnf-product-constants'

export default class EnhancedListDataService extends OrderDataService {
  httpService = new HttpService()

  //Heirarchy
  fetchOrderProductGroups = (bsgId, orderId, orderType, clientOrderId, body) => {
    const orderPath =
      orderType === OrderType.Client
        ? `/clientOrder/${orderId}/multiple-aggregates`
        : `/clientOrder/${clientOrderId}/doorOrder/${orderId}/multiple-aggregates`
    const url = `${config.buyingBoardServiceRestEndpoint}${PRODUCT_SERVICE_ENDPOINTS.ENHANCED_PRODUCT_COMMON_PATH}/${bsgId}${orderPath}`

    return this.httpService
      .post(url, body, {
        ...this.getOptionsHeader()
      })
      .then(response => response?.data)
  }

  // Products
  fetchProductsByGrouping = (bsgId, orderId, orderType, clientOrderId, body) => {
    const orderPath =
      orderType === OrderType.Client
        ? `/clientOrder/${orderId}/products`
        : `/clientOrder/${clientOrderId}/doorOrder/${orderId}/products`

    const url = `${config.buyingBoardServiceRestEndpoint}${PRODUCT_SERVICE_ENDPOINTS.ENHANCED_PRODUCT_COMMON_PATH}/${bsgId}${orderPath}`

    return this.httpService
      .post(url, body, {
        ...this.getOptionsHeader()
      })
      .then(response => response?.data)
  }

  addAllProductsToEnhancedClientOrder = async (
    orderId: string,
    buyingSessionGroupId,
    body: any
  ) => {
    const url = `${config.buyingBoardServiceRestEndpoint}${PRODUCT_SERVICE_ENDPOINTS.ENHANCED_PRODUCT_COMMON_PATH}/${buyingSessionGroupId}/clientOrder/${orderId}/book`

    return this.httpService
      .post(url, body, {
        ...this.getOptionsHeader()
      })
      .then(response => response.data?.data)
  }

  updateProductQuantity = (
    buyingSessionGroupId: string,
    bspId: string,
    orderId: string,
    payload: any
  ) => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}${PRODUCT_SERVICE_ENDPOINTS.ENHANCED_PRODUCT_COMMON_PATH}/${buyingSessionGroupId}/clientOrder/${orderId}/buyingSessionProduct/${bspId}`
      return this.httpService
        .patch(url, payload, {
          ...this.getOptionsHeader()
        })
        .then(resp => resp?.data?.data)
    } catch (e) {
      console.log(e)
      // throw e
    }
  }
  rollUpAllQuantities = (buyingSessionGroupId: string, orderId: string, payload: any) => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}${PRODUCT_SERVICE_ENDPOINTS.ENHANCED_PRODUCT_COMMON_PATH}/${buyingSessionGroupId}/clientOrder/${orderId}`
      return this.httpService
        .patch(url, payload, {
          ...this.getOptionsHeader()
        })
        .then(resp => resp?.data?.data)
    } catch (e) {
      console.log(e)
      // throw e
    }
  }

  splitAllQuantities = (buyingSessionGroupId: string, orderId: string, payload: any) => {
    const url = `${config.buyingBoardServiceRestEndpoint}${PRODUCT_SERVICE_ENDPOINTS.ENHANCED_PRODUCT_COMMON_PATH}/${buyingSessionGroupId}/clientOrder/${orderId}/splitAllProducts`
    return this.httpService
      .patch(url, payload, {
        ...this.getOptionsHeader()
      })
      .then(resp => resp?.data?.data)
      .catch(e => {
        console.error(e)
      })
  }

  //Update door/draft quantity

  updateDoorOrderDraftQuantity = (
    buyingSessionGroupId: string,
    bspId: string,
    orderId: string,
    doorOrderId: string = '',
    payload
  ) => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}${PRODUCT_SERVICE_ENDPOINTS.ENHANCED_PRODUCT_COMMON_PATH}/${buyingSessionGroupId}/clientOrder/${orderId}/doorOrder/${doorOrderId}/buyingSessionProduct/${bspId}`

      return this.httpService
        .patch(url, payload, {
          ...this.getOptionsHeader()
        })
        .then(resp => resp?.data?.data)
    } catch (e) {
      console.log(e)
      // throw e
    }
  }

  //Update single size quantity
  updateDoorOrderSizeQuantity = (
    buyingSessionGroupId: string,
    bspId: string,
    orderId: string,
    doorOrderId: string = '',
    payload,
    sizeId: string
  ) => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}${PRODUCT_SERVICE_ENDPOINTS.ENHANCED_PRODUCT_COMMON_PATH}/${buyingSessionGroupId}/clientOrder/${orderId}/doorOrder/${doorOrderId}/buyingSessionProduct/${bspId}/size/${sizeId}`
      return this.httpService
        .patch(url, payload, {
          ...this.getOptionsHeader()
        })
        .then(resp => resp?.data?.data)
    } catch (e) {
      console.log(e)
      // throw e
    }
  }

  // *********** Quantity Sub Section ***********
  // **ToDo:** Improve from response?.data?.data

  bookDoorOrder = async (clientOrderId, bspId, doorOrderIds) => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}${ORDER_SERVICE_ENDPOINTS.BOOK_UNBOOK_DOOR}/${clientOrderId}/buyingSessionProduct/${bspId}`

      const response = await this.httpService.post(
        url,
        { doorOrderIds },
        {
          ...this.getOptionsHeader()
        }
      )
      return response?.data?.data
    } catch (e) {
      console.log(e)
      // throw e
    }
  }

  unbookDoors = async (
    clientOrderId,
    bspId,
    doorOrderIds,
    filterData = {},
    searchKey = ''
  ) => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}${ORDER_SERVICE_ENDPOINTS.BOOK_UNBOOK_DOOR}/${clientOrderId}/buyingSessionProduct/${bspId}/unbook`
      const response = await this.httpService.post(
        url,
        {
          params: {
            ...(searchKey ? { searchKey } : {})
          },
          ...(doorOrderIds?.length
            ? {
                doorOrderIds,
                filter: filterData
              }
            : { filter: filterData })
        },
        {
          ...this.getOptionsHeader()
        }
      )
      return response?.data?.data
    } catch (e) {
      console.log(e)
      throw e
    }
  }

  bulkUpdateProductQty = (
    buyingSessionGroupId: string,
    clientOrderId,
    bspId,
    payload
  ) => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}${PRODUCT_SERVICE_ENDPOINTS.ENHANCED_PRODUCT_COMMON_PATH}/${buyingSessionGroupId}/clientOrder/${clientOrderId}/buyingSessionProduct/${bspId}/bulk`
      return this.httpService
        .patch(url, payload, {
          ...this.getOptionsHeader()
        })
        .then(resp => resp?.data?.data)
    } catch (e) {}
  }

  pasteTemplate = (buyingSessionGroupId: string, clientOrderId, bspId, payload) => {
    const url = `${config.buyingBoardServiceRestEndpoint}${PRODUCT_SERVICE_ENDPOINTS.ENHANCED_PRODUCT_COMMON_PATH}/${buyingSessionGroupId}/clientOrder/${clientOrderId}/buyingSessionProduct/${bspId}/pasteTemplate`
    return this.httpService
      .post(url, payload, {
        ...this.getOptionsHeader()
      })
      .then(resp => resp?.data?.data)
      .catch(e => {
        console.error(e)
        return e
      })
  }

  fetchOrderWarningSummary = (bsgId, orderId, orderType, clientOrderId, quantityType) => {
    const orderPath =
      orderType === OrderType.Client
        ? `/clientOrder/${orderId}/validation-warnings`
        : `/clientOrder/${clientOrderId}/doorOrder/${orderId}/validation-warnings`
    const url = `${config.buyingBoardServiceRestEndpoint}${PRODUCT_SERVICE_ENDPOINTS.ENHANCED_PRODUCT_COMMON_PATH}/${bsgId}${orderPath}?quantityType=${quantityType}`

    return this.httpService
      .get(url, {
        ...this.getOptionsHeader()
      })
      .then(response => response?.data)
      .catch(e => {
        console.error(e)
        return e
      })
  }
}
